export default function Hero() {
    return (
        <div className="w-full h-[360px] relative overflow-hidden">
            <img src="/assets/cover.png" alt="colorful pixelated background" className="absolute" />
        </div>
    )
}